import dayjs from 'dayjs';
import { inRange, isNil } from 'lodash-es';

/**
 * utils function
 * @func deduplicateByKey
 * De-duplicate an array of objects based on the uniqueness of the key
 * @param arrayWithDuplicates 待去重的对象数组
 * @param key 去重的key键
 * @return uniqueList 去重后的对象数组
 */

export const deduplicateByKey = (arrayWithDuplicates: any[], key) => {
  return arrayWithDuplicates;
};
export const hasIllegalChar = (str) => {
  // 用户配置常规信息，禁止输入下述字符, e.g:【需求名称】
  //,  \ / : * ? " < > | 空格
  const pattern = /[，：？\,\:\?\*\\\/\"\>\<\|\s]/;
  return pattern.test(str);
};

export const checkNameRuleIllegalChar = (str) => {
  // 用户配置命名正则，禁止输入下述字符, e.g:【文件名称、组名称、mesh名称、材质球名称、阶段名称】
  //,   / : " < >  空格
  const reg = /[:：，？,\/"<>\s]/g;
  return reg.test(str);
};

export const camelToKebab = (str) => {
  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
};
export const token2CSSVar = (token: string, prefix = '') => {
  return `--${prefix ? `${prefix}-` : ''}${token}`
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, '$1-$2')
    .replace(/([a-z])([A-Z0-9])/g, '$1-$2')
    .toLowerCase();
};
export const isPictureFile = (fileName) => {
  const index = fileName.lastIndexOf('.');
  //获取后缀
  const ext = fileName.substr(index + 1);
  return ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'tiff'].indexOf(ext.toLowerCase()) !== -1;
};

export const formatSize = (byte) => {
  if (byte === undefined) {
    return '-';
  }
  const gb = (byte / 1024 / 1024 / 1024).toFixed(1);
  if (Number(gb) >= 1) {
    return `${gb}GB`;
  }
  const mb = (byte / 1024 / 1024).toFixed(1);
  if (Number(mb) >= 1) {
    return `${mb}MB`;
  }
  const kb = (byte / 1024).toFixed(1);
  if (Number(kb) >= 1) {
    return `${kb} KB`;
  }
  return `${byte} Byte`;
};

export const formatSizeToByte = (value, unit) => {
  const size = Number(value) || 0;
  const sizeUnit = unit?.toLowerCase() || 'mb';
  switch (sizeUnit) {
    case 'bit':
      return size / 8;
    case 'byte':
      return size;
    case 'kb':
      return size * 1024;
    case 'mb':
      return size * 1024 * 1024;
    case 'gb':
      return size * 1024 * 1024 * 1024;
  }
};

export const formatByteByUnit = (value, unit) => {
  const size = Number(value) || 0;
  const sizeUnit = unit?.toLowerCase() || 'mb';
  switch (sizeUnit) {
    case 'bit':
      return size * 8;
    case 'byte':
      return size;
    case 'kb':
      return size / 1024;
    case 'mb':
      return size / 1024 / 1024;
    case 'gb':
      return size / 1024 / 1024 / 1024;
  }
};

export const serialize = function (obj) {
  const str: string[] = [];
  for (let p in obj) {
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  }
  return str.join('&');
};

export const formatTime = (time, format = 'YYYY-MM-DD HH:mm:ss') => {
  return time ? dayjs(time).format(format) : '-';
};

export const trimFormSpace = (e: any) => {
  return e.target.value.replace(/\s+/g, '');
};

export const numberInRange = (number: number | undefined, start: number = 0, end: number = 0) => {
  if (isNil(number)) return false;
  if (number === end) return true;
  return inRange(number, start, end);
};

//格式化用户积分
export function formatScore(score: number) {
  // 兼容score是负值的情况
  if (score < 0) {
    return `-${formatScore(-score)}`;
  }
  let num = (score || 0).toString();

  let result = '';
  const numStr = num.split('.');
  if (numStr.length > 1) {
    result = `.${numStr[1]}`;
    num = numStr[0];
  }
  while (num.length > 3) {
    result = `,${num.slice(-3)}${result}`;
    num = num.slice(0, num.length - 3);
  }
  return `${num}${result}`;
}
// 格式化积分为指定单位
export function formatIntegral(config) {
  const { num, boundary = 100000, divisor = 10000, decimal = 2, cell = 'w' } = config;

  let result = String(num / divisor);

  if (num % divisor === 0 && num >= boundary) {
    return `${result},${'0'.repeat(decimal)}${cell}`;
  }

  if (num > boundary) {
    if (result.includes('.')) {
      let [prefix, suffix] = result.split('.');
      while (suffix.length < decimal) {
        suffix += '0';
      }
      return `${prefix},${suffix.slice(0, decimal)}${cell}`;
    }

    return Number(result);
  }

  return num;
}
export const getStrLen = (value: string) => {
  if (!value) return 0;
  let len = 0;
  for (let i = 0; i < value.length; i++) {
    if (value.charCodeAt(i) > 127 || value.charCodeAt(i) === 94) {
      len += 1;
    } else {
      len += 0.5;
    }
  }
  return Math.floor(len);
};
export const countFormat = (count: number) => {
  if (count < 10000) return count;

  return `${parseFloat((count / 10000).toFixed(1))}w`;
};
export function judgeIsDanluDomain() {
  // 判断window.location.host是否属于丹炉域名
  return window.location.hostname.endsWith('netease.com');
}

export const formatArray = (array?: Array<string>): string => {
  const showText = array
    ?.filter?.((v) => !!v)
    ?.reduce?.((pre, acc, index) => {
      const isFirst = index === 0;
      return isFirst ? `${acc}` : `${pre}、${acc}`;
    }, '');
  return showText || '-';
};

export const strToPercent = (str: string) => {
  const num = Number(str);
  //限制num在0-100之间
  const no = Math.min(Math.max(num, 0), 100);

  if (isNaN(num)) return '0%';

  // return no.toFixed(2) + '%';
  // 保留后两位小数
  return no.toFixed(2).replace(/\.00$/, '') + '%';
};

//根据文件的后缀名，匹配文件的mimeType
export const getMimeType = (ext: string) => {
  const map = {
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ppt: 'application/vnd.ms-powerpoint',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    pdf: 'application/pdf',
    jpeg: 'image/jpeg',
    jpg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    txt: 'text/plain',
    zip: 'application/zip',
    rar: 'application/x-rar-compressed',
    mp4: 'video/mp4',
    mp3: 'audio/mp3',
    wma: 'audio/x-ms-wma',
    wav: 'audio/wav',
    wmv: 'video/x-ms-wmv',
    avi: 'video/x-msvideo',
    flv: 'video/x-flv',
    rmvb: 'application/vnd.rn-realmedia-vbr',
    rm: 'application/vnd.rn-realmedia',
    mov: 'video/quicktime',
  };
  return map[ext] || '';
};

// 复制内容
export const copyPath = (path) => {
  const tempInput = document.createElement('input');
  tempInput.value = path;
  document.body.appendChild(tempInput);

  tempInput.select();
  tempInput.setSelectionRange(0, 99999); // 兼容移动端

  document.execCommand('copy');
  document.body.removeChild(tempInput);
};
//滚动到光标位置
export const scrollSelectionIntoView = () => {
  // Get current selection
  const selection = window.getSelection();

  // Check if there are selection ranges
  if (!selection?.rangeCount) {
    return;
  }

  // Get the first selection range. There's almost never can be more (instead of firefox)
  const firstRange = selection.getRangeAt(0);

  // Sometimes if the editable element is getting removed from the dom you may get a HierarchyRequest error in safari
  if (firstRange.commonAncestorContainer === document) {
    return;
  }

  // Create an empty br that will be used as an anchor for scroll, because it's imposible to do it with just text nodes
  const tempAnchorEl = document.createElement('br');

  // Put the br right after the caret position
  firstRange.insertNode(tempAnchorEl);

  // Scroll to the br. I personally prefer to add the block end option, but if you want to use 'start' instead just replace br to span
  tempAnchorEl.scrollIntoView({
    block: 'end',
  });

  // Remove the anchor because it's not needed anymore
  tempAnchorEl.remove();
};
